import { Store } from 'vuex';
import { VuexSaga } from 'vuex-coolstory';
import { createVuexStore, Module } from 'vuex-simple';

import aps, { ApsModule } from '@/HostApp/store/ApsModules/ApsModule';
import hostServices, { HostServices } from '@/HostApp/services';
import bizApiStorage from '@/HostApp/store/BizApiStorage/bizApiStorage';

export class RootStore {
	constructor() {
		const { hostServices, aps } = this;

		Object.defineProperty(this, 'hostServices', {
			get: (): HostServices => hostServices,
			set: (): boolean => true
		});

		Object.defineProperty(this, 'aps', {
			get: (): ApsModule => aps,
			set: (): boolean => true
		});
	}

	@Module()
	public hostServices = hostServices;

	@Module()
	public aps = aps;

	@Module()
	public bizApiStorage = bizApiStorage;
}

class EmptyRootStore {}

const getRootStore = (isHost: boolean): RootStore | EmptyRootStore => {
	return isHost ? new RootStore() : new EmptyRootStore();
};

let index: Store<RootStore> | null = null;

export default (isHost: boolean): Store<RootStore> => {
	index =
		index ||
		createVuexStore(getRootStore(isHost), {
			strict: false,
			modules: {},
			plugins: [
				VuexSaga({
					sagas: []
				})
			]
		});
	return index;
};
